<template>
  <div class="mypage-blocked-user-list-section">
    <ul class="mypage-blocked-user-list-section__list">
      <li
        v-for="user in dummyListData"
        :key="user.id"
        class="mypage-blocked-user-list-section__item"
      >
        <mypage-blocked-user-item-section :user="user" />
      </li>
    </ul>
    <div class="mypage-blocked-user-list-section__pagination">
      <pagination-section :totalPages="totalPage" :currentPage="currentPage" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import MypageBlockedUserItemSection from '@/components/MypageBlockedUserListPage/MypageBlockedUserListPane/MypageBlockedUserItemSection.vue'
import PaginationSection from '@/components/common/Pagination/PaginationSection.vue'

export default defineComponent({
  name: 'MypageBlockedUserListSection',
  components: { PaginationSection, MypageBlockedUserItemSection },
  setup() {
    // ブロックユーザーのリストデータ
    const dummyListData = [
      {
        id: '1',
        type: 'paid-user',
        name: 'kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123kazu123',
      },
      {
        id: '2',
        type: 'ambassador',
        name: 'yumi5678',
      },
      {
        id: '3',
        type: 'jrp-staff',
        name: 'tomo_89',
      },
      {
        id: '4',
        type: 'driver',
        name: 'sora2k',
      },
      {
        id: '5',
        type: 'team-user',
        name: 'rika777',
      },
      {
        id: '6',
        type: 'guest',
        name: 'akira_35',
      },
      {
        id: '7',
        type: 'free-user',
        name: 'mio4ever',
      },
      {
        id: '8',
        type: 'special-supporter',
        name: 'shinobi9',
      },
      {
        id: '9',
        type: 'special-supporter',
        name: 'shinobi9',
      },
    ]

    const totalPage = ref(12)
    const currentPage = ref(1)

    return {
      dummyListData,
      totalPage,
      currentPage,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-blocked-user-list-section {
  max-width: 800px;
  height: 100%;
  margin: 0 auto;

  &__list {
    padding: 24px 16px 0;
  }

  &__item {
    border-top: 1px solid $black10;

    &:last-child {
      border-bottom: 1px solid $black10;
    }
  }

  &__pagination {
    display: flex;
    justify-content: center;
  }
}
</style>
